var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLaw140 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 140,
  height: 140,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-decorative-coral)",
  fillRule: "evenodd",
  d: "M42 124h57v1H42v-1Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M71 28V16h-1v12H34.232L10 64.349v.151C10 73.217 18.23 85 34.5 85S59 73.217 59 64.5v-.151L35.434 29H70v86h1V29h34.566L82 64.349v.151c0 8.717 8.23 20.5 24.5 20.5S131 73.217 131 64.5v-.151L106.768 28H71ZM57.566 64 34.5 29.401 11.434 64h46.132ZM11.01 65c.309 8.107 8.079 19 23.49 19 15.411 0 23.181-10.893 23.49-19H11.01Zm72 0c.309 8.107 8.079 19 23.49 19 15.411 0 23.181-10.893 23.49-19H83.01Zm46.556-1H83.434L106.5 29.401 129.566 64Z",
  clipRule: "evenodd"
})));
export { SvgLaw140 as ReactComponent };
export default __webpack_public_path__ + "566b0366cd6aecfafbb75b50e26a09ba.svg";